import React from "react";
/* import { MediaPlayer, MediaProvider, Poster,  } from "@vidstack/react";
import { defaultLayoutIcons, DefaultVideoLayout } from '@vidstack/react/player/layouts/default'; */
import { MediaPlayer, MediaProvider,Poster } from '@vidstack/react';
import { PlyrLayout, plyrLayoutIcons } from '@vidstack/react/player/layouts/plyr';
import '@vidstack/react/player/styles/base.css';
import '@vidstack/react/player/styles/plyr/theme.css';
import '@vidstack/react/player/styles/default/theme.css';
import '@vidstack/react/player/styles/default/layouts/video.css';

function YoutubeComponentV2({url, poster, autoPlay = true}) {
  return (
    <MediaPlayer
      
      autoPlay={autoPlay}
     /*  title="Sprite Fight" */
      src={url}
      className="!w-[94%] z-[2]"
      style={{aspectRatio: "16 / 8.8"}}
      viewType="video"
      streamType="on-demand"
      crossOrigin
      playsInline
      logLevel="warn"
      
    >
      {/* <MediaProvider>
        <Poster src="https://i.ytimg.com/vi/_6c2_eeoL_Q/maxresdefault.jpg" 
         className="tw:absolute tw:inset-0 tw:block tw:h-full tw:w-full tw:bg-black tw:rounded-md tw:opacity-0 tw:transition-opacity tw:data-[visible]:opacity-100 tw:[&>img]:h-full tw:[&>img]:w-full tw:[&>img]:object-cover" />
         
      </MediaProvider> */}
      <MediaProvider>
        <Poster
          className="vds-poster bg-cover object-cover !aspect-video"
          src={poster}
         /*  alt="Sprite Fight Poster" */
        />

        
      </MediaProvider>

      
      {/* <DefaultVideoLayout  icons={defaultLayoutIcons} /> */}
      <PlyrLayout  icons={plyrLayoutIcons} />
    </MediaPlayer>
  );
}

export default YoutubeComponentV2;
